import { z } from 'zod'

export const scanResultResponseSchema = z.object({
  operations: z.number().int(),
  orders: z.number().int(),
  expectedPayments: z.number().int(),
})

export type ScanResultResponseDto = z.infer<typeof scanResultResponseSchema>
